
import MagicWand from "~/assets/images/magicWand.svg";

export default {
  data() {
    return {
      MagicWand
    };
  }
};
